import React from "react";
import { useSearchParams } from "react-router-dom";
import {Pagination} from "@components";
import { useMember } from "@hooks";

function MemberTable({ handleRowClick, selectedId }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;

  const queryParam = {
    comdCode: searchParams.get("comdCode") || "",
    searchCnd: searchParams.get("searchCnd") || "",
    searchWrd: searchParams.get("searchWrd") || "",
    bizRegNo: searchParams.get("bizRegNo") || "",
    checkVal: searchParams.get("checkVal"),
    pageIndex,
    recordCountPerPage,
  };
 
  const { data, selectedItems, isAllChecked, handleSelectAll, handleSelectItem, handleExcelDownload, memberDelete } = useMember(queryParam);

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };
  
  return (
  <>  
    <div className="section-tit-wrap">
        <h3 className="border-left-primary">
        &nbsp;회원 목록
        <span className="total-txt">
            {" "} | 총 <span className="red">{data?.totalcount} </span> 명
        </span>
        </h3>
        <div className="btn-box">
            <button type="button" className="btn-excel" onClick={handleExcelDownload}>엑셀</button>
            <button type="button" className="btn-delete" onClick={memberDelete}>삭제</button>
        </div>
    </div>
    <div className="table-container">
        <table className="table-list" style={{ width: "100%" }}>
        <colgroup>
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "20%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "10%" }} />
        </colgroup>
        <thead>
            <tr>
            <th><input type="checkbox" checked={isAllChecked} onChange={(e) => handleSelectAll(e.target.checked)} /></th>
            <th>No</th>
            <th>아이디</th>
            <th>이름</th>
            <th>전화번호</th>
            <th>이메일</th>
            <th>소속</th>
            <th>상태</th>
            </tr>
        </thead>
        <tbody>
            {data?.resultList && data.resultList.length > 0 ? (
            data.resultList.map((item, idx) => (
                
                <tr
                    key={item.memberId}
                    style={{ 
                        backgroundColor:
                        selectedId === item.memberId ? "#f2f2f2" : "",
                        cursor: "pointer" }}
                        onClick={() => handleRowClick(item)} >
                <td>
                    <input  
                        type="checkbox"
                        checked={selectedItems.includes(item.memberId)}
                        onChange={(e) => {
                            e.stopPropagation();
                            handleSelectItem(item.memberId);
                    }} />
                </td>
                <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                <td style={{textAlign:"left"}}>{item.memberId}</td>
                <td>{item.memberNm}</td>
                <td>{item.phoneNo}</td>
                <td style={{textAlign:"left"}}>{item.email}</td>
                <td>{item.companyNm}</td>
                <td>{item.comdName}</td>
                </tr>
            ))
            ) : (
            <tr>
                <td colSpan={8} style={{ textAlign: "center" }}>
                조회 결과가 없습니다.
                </td>
            </tr>
            )}
        </tbody>
        </table>
    </div>
        {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
            <Pagination
                totalPages={Math.ceil(
                data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                )}
                currentPage={pageIndex}
                onPageChange={handlePageChange}
                pageRangeDisplayed={10}
            />
        )}
  </>          
  );
}

export default MemberTable;
